import * as z from "zod";

export const createUserSchema = z
  .object({
    username: z
      .string()
      .min(3, "Username must be between 3 and 32 characters long")
      .max(32, "Username must be between 3 and 32 characters long"),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters long"),
    confirmPassword: z.string(),
    token: z.string().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export const userAuthSchema = z.object({
  username: z.string(),
  password: z.string(),
  token: z.string().optional(),
});
